export var currencyDecimals = {
    BYR: 0,
    XOF: 0,
    BIF: 0,
    XAF: 0,
    CLP: 0,
    KMF: 0,
    DJF: 0,
    XPF: 0,
    GNF: 0,
    ISK: 0,
    JPY: 0,
    KRW: 0,
    PYG: 0,
    RWF: 0,
    UGX: 0,
    UYI: 0,
    VUV: 0,
    VND: 0,
    BHD: 3,
    IQD: 3,
    JOD: 3,
    KWD: 3,
    LYD: 3,
    OMR: 3,
    TND: 3,
    CLF: 4
}; //all others: 2
export var getCurrencySymbols = function (baseCurrency) {
    return {
        EUR: '\u20AC',
        GBP: '\u00A3',
        JPY: '\u00A5',
        CAD: baseCurrency === 'CAD' ? '$' : 'CAD',
        USD: baseCurrency === 'USD' ? '$' : 'USD'
    };
};
